import { gql } from "@apollo/client";
import { ONSEN_URL } from "helpers/environment";
import { gaEvent } from "helpers/gtag";
import isUniqueVideoPlay from "helpers/isUniqueVideoPlay";
import useActionFragment from "helpers/useActionFragment";
import useData from "helpers/useData";
import React from "react";

import HighlightPlayerHeader, { HighlightPlayerHeaderFragment } from "./HighlightPlayerHeader";
import ReelVideoPlayer from "./ReelVideoPlayer";

export const HighlightPlayerFragment = gql`
  fragment HighlightPlayerFragment on Event {
    title
    thumbnailUrl
    videoUrl
    videoPending
    shareable
    ...HighlightPlayerHeaderFragment
  }
  ${HighlightPlayerHeaderFragment}
`;

// footer: shown under the header, eg the dialog's previous / next / close; the share page has none
export default function HighlightPlayer({ event, eventId, footer }) {
  useData(
    gql`
      query EventPage($eventId: ID!) {
        event(id: $eventId) {
          id
          videoPending
        }
      }
    `,
    { eventId },
    { pollInterval: 5000, skip: !event || !event.videoPending },
  );

  const eventIncreaseViewCount = useActionFragment("eventIncreaseViewCount", "event { id viewCount }");
  const eventIncreaseShareCount = useActionFragment("eventIncreaseShareCount");

  return (
    <>
      <ReelVideoPlayer
        title={event?.title}
        header={<HighlightPlayerHeader event={event} />}
        footer={footer}
        poster={event?.thumbnailUrl}
        videoUrl={event?.videoUrl}
        shareUrl={`${ONSEN_URL}/event/${eventId}`}
        sharingDisabled={event?.shareable === false}
        videoPending={event?.videoPending}
        vidoeUnavailable={!!event && !event.videoUrl && !event.videoPending}
        onShared={({ share_destination }) => {
          gaEvent("event_share", {
            share_destination,
          });
          eventIncreaseShareCount({ input: { eventId } });
        }}
        onVideoPlay={() => {
          const isUnique = isUniqueVideoPlay("event_" + eventId);
          gaEvent("event_play", {
            is_unique: isUnique,
          });
          eventIncreaseViewCount({ input: { eventId, isUnique } });
        }}
        onDownload={() => {
          gaEvent("download", { type: "event" });
        }}
      />
    </>
  );
}
